import {
    Action,
    Selector,
    StateContext,
    State,
    Store
} from '@ngxs/store';

import { NotificationType, Notification } from '../../models/notification/notification';
import { Notify } from '../actions/notification.action';
import { ToastyService } from 'ng2-toasty';
import { GuidHelper } from '../../helpers/guid-helper';

export class NotificationStateModel {
    id: string | null;
    title: string | null;
    msg: string | null;
    theme: string | null;
    timeout: number | 0;
    showClose: boolean | null;
    type: NotificationType;
}

@State<NotificationStateModel>({
    name: 'notification',
    defaults: {
        id: null,
        msg: null,
        theme: null,
        showClose: null,
        timeout: 0,
        title: null,
        type: null
    }
})
export class NotificationState {
    constructor(
        protected store: Store,
        protected toastService: ToastyService
    ) {}

    @Selector()
    static NOTIFICATION(state: NotificationStateModel) {
      return <Notification>state;
    }

    @Selector()
    static NOTIFICATION_HASH(state: NotificationStateModel) {

      return state.id;
    }

    @Action(Notify)
    Success(
      { patchState, getState }: StateContext<NotificationStateModel>,
      { notification }: Notify
    ) {
        patchState({
            msg: notification.msg,
            theme: notification.theme,
            showClose: notification.showClose,
            timeout: notification.timeout,
            title: notification.title,
            type: notification.type,
            id: GuidHelper.generate()
        });
    }
}

